import { useLocation } from 'react-router-dom';

export default function useQueryParams() {
    const { search } = useLocation();
    const urlSearchParams = new URLSearchParams(search);
    return Object.fromEntries(urlSearchParams.entries());
}
